<template>
  <div class="graph-container">
      <div class="graph-header">
        <h5>{{ title }} </h5>
        <span v-if="isLoading || isUpdating">
          <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        </span>
      </div>
      <div v-if="!isLoading" style="width: 100%">
        <apexchart type="scatter" :options="generateDefaultChartOptions(colors, formatter)" :series="data" height="500"></apexchart>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'LeadTimeGraph',
  props: ['title', 'data', 'isLoading', 'isUpdating', 'colors', 'formatter', 'updateData'],
  data () {
    return {
      maxDayZoom: 7,
      currentDayZoom: 30,
      zoomActionDebouncer: [],
    }
  },
  methods: {
    zoomed: function(chartContext, { xaxis }) {
      let focusedDayCount = 30;
      var d = new Date(0);
      d.setTime(xaxis.min);
      var start = Math.floor(new Date().getTime() / (3600 * 24 * 1000));
      var end = Math.floor(d.getTime() / (3600 * 24 * 1000));
      var diff = start - end;

      if(!Number.isNaN(diff)) 
        focusedDayCount = diff + 1;

      this.zoomActionDebouncer.push(focusedDayCount)
      setTimeout(() => {
        let last = this.zoomActionDebouncer.shift()
        if(this.zoomActionDebouncer.length != 0)
          return;
        this.currentDayZoom = last
        if(last > this.maxDayZoom) {
          console.log(`Fetching data -> days:${last - this.maxDayZoom} offset-${this.maxDayZoom}`)
          this.updateData(last - this.maxDayZoom, this.maxDayZoom)
        }
      }, 500)
     
    },
    generateDefaultChartOptions (colorArray, formatter = (v) => v.toFixed(), zoomed = this.zoomed) {
      return {
        annotations: {
          position: 'front',
          yaxis: [{
            y: this.data[0].leadTimeMean,
            borderColor: '#000',
            offsetY: -10,
            offsetX: 30,
            width: '100%',
            label: {
              borderColor: '#000',
              style: {
                color: '#fff',
                background: '#000'
              },
              text: `Lead-time moyen ${this.data[0].leadTimeMean}`
            }
          }],
        },
        chart: {
          height: 500,
          width: '100%',
          type: 'scatter',
          events: {
            beforeZoom: function(chartContext, { xaxis }) {
              return {
                xaxis: {
                  max: xaxis.max > Date.now() ? Date.now() : xaxis.max,
                  min: xaxis.min
                }
              } 
            },
            zoomed
          },
          zoom: {
            enabled: true,
            type: 'x',  
            autoScaleYaxis: false,
          },
        },
        colors: colorArray,
        dataLabels: {
          enabled: false,
          background: {
            borderWidth: 0,
            padding: 10,
            borderRadius: 10,
          },
        },
        xaxis: {
          type: 'datetime',
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter,
          }
        },
        tooltip: {
          enabled: true,
          x: {
            format: 'dd/MM/yy'
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            var listeOfRef = w.config.series[seriesIndex].references[dataPointIndex][1]
            var htmlText = '<div class="tooltip-card-id">'+listeOfRef+'</div>'
            return '<div class="custom-tooltip">' +
              '<div class="custom-tooltip-series">' + htmlText + '</div>' +
              '</div>'
          }
        },
      }
    },
  },
}
</script>

<style type="css" scoped>
.graph-container {
  margin: 0;
  padding: 0;
  min-height: 100px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

.graph-header {
  position: relative;
  padding: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.graph-header > span {
  position: absolute;
  left: 0.5em;
  top: 0.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/graph/LeadTimeGraph.vue